import { t } from './i18n.es.js';
import { PaymentMethodCode } from './types.es.js';

const getPaymentMethod = (paymentMethodCode) => {
    if (!paymentMethodCode) {
        return '';
    }
    switch (paymentMethodCode.toUpperCase()) {
        case PaymentMethodCode.VNPAYQR:
        case PaymentMethodCode.VNPAY_QRCODE:
        case PaymentMethodCode.VNPAY_GATEWAY:
        case PaymentMethodCode.MOBILE_BANKING:
        case PaymentMethodCode.PAYBILL:
            return t('Thanh toán trực tuyến');
        case PaymentMethodCode.CTT:
            return t('Thanh toán Online qua cổng VNPAY');
        case PaymentMethodCode.COD:
            return t('Thanh toán khi nhận hàng');
        case PaymentMethodCode.LOYALTY:
            return t('Tiêu điểm thành viên');
        case PaymentMethodCode.CASH:
            return t('Tiền mặt');
        case PaymentMethodCode.VNPAY_INSTALLMENT_CREDIT:
        case PaymentMethodCode.ALEPAY_INSTALLMENT_CREDIT:
            return t('Thanh toán trả góp');
        default:
            return paymentMethodCode || '';
    }
};
const sha256 = async (message) => {
    const msgBuffer = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
        .map((b) => ('00' + b.toString(16)).slice(-2))
        .join('');
    return hashHex;
};
const checksumGenerator = async (secretKey, body) => {
    if (!body) {
        return;
    }
    const fields = [
        'orderCode',
        'userId',
        'terminalCode',
        'merchantCode',
        'totalPaymentAmount',
        'successUrl',
        'cancelUrl',
    ];
    const hashData = [];
    fields.forEach((f) => {
        hashData.push(body[f] || '');
    });
    const { loyalty, card, qr, credit, offline, installment } = body.payments;
    const arrayPayments = [loyalty, card, qr, credit, offline, installment];
    arrayPayments.forEach((p) => {
        if (p) {
            hashData.push(p.clientTransactionCode);
            hashData.push(p.merchantMethodCode);
            hashData.push(p.methodCode);
            hashData.push(p.amount);
        }
    });
    const hashString = hashData.join('|');
    return sha256(secretKey + hashString);
};
const checksumGeneratorCreateToken = (secretKey, body) => {
    if (!body) {
        return;
    }
    const { merchantMethodCode, clientTransactionCode, userId, successUrl, cancelUrl, cardType, bankCode, } = body;
    const str = [
        merchantMethodCode,
        clientTransactionCode,
        successUrl,
        cancelUrl,
        cardType,
        bankCode,
        userId,
    ].join('|');
    return sha256(secretKey + str);
};
const checksumGeneratorRemoveToken = (secretKey, body) => {
    if (!body) {
        return;
    }
    const { merchantMethodCode, clientTransactionCode, userId, token } = body;
    const str = [merchantMethodCode, clientTransactionCode, userId, token].join('|');
    return sha256(secretKey + str);
};
const getDateWithFormatyyMMddHHmm = (currentTimestampValue) => {
    const currentTimestamp = currentTimestampValue || Date.now() + 86400 * 1000;
    const date = new Date(currentTimestamp);
    const yy = date.getFullYear().toString().substring(2);
    const MM = formatTimeNumberToString(date.getMonth() + 1);
    const dd = formatTimeNumberToString(date.getDate());
    const HH = formatTimeNumberToString(date.getHours());
    const mm = formatTimeNumberToString(date.getMinutes());
    return `${yy}${MM}${dd}${HH}${mm}`;
};
const formatTimeNumberToString = (timeNumber) => timeNumber < 10 ? `0${timeNumber}` : timeNumber;

export { checksumGenerator, checksumGeneratorCreateToken, checksumGeneratorRemoveToken, getDateWithFormatyyMMddHHmm, getPaymentMethod, sha256 };
